var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_157_3641",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.538086,
    y: 0.676758,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_157_3641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37175 11.5101H14.7051V9.84341H6.37175V11.5101ZM10.5384 19.0101C9.38563 19.0101 8.3023 18.7912 7.28841 18.3534C6.27452 17.9162 5.39258 17.3226 4.64258 16.5726C3.89258 15.8226 3.29897 14.9406 2.86174 13.9267C2.42397 12.9129 2.20508 11.8295 2.20508 10.6767C2.20508 9.52397 2.42397 8.44064 2.86174 7.42675C3.29897 6.41286 3.89258 5.53091 4.64258 4.78091C5.39258 4.03091 6.27452 3.43703 7.28841 2.99925C8.3023 2.56203 9.38563 2.34341 10.5384 2.34341C11.6912 2.34341 12.7745 2.56203 13.7884 2.99925C14.8023 3.43703 15.6842 4.03091 16.4342 4.78091C17.1842 5.53091 17.7779 6.41286 18.2151 7.42675C18.6529 8.44064 18.8717 9.52397 18.8717 10.6767C18.8717 11.8295 18.6529 12.9129 18.2151 13.9267C17.7779 14.9406 17.1842 15.8226 16.4342 16.5726C15.6842 17.3226 14.8023 17.9162 13.7884 18.3534C12.7745 18.7912 11.6912 19.0101 10.5384 19.0101Z",
    fill: "#F03E3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkDelete);
export default __webpack_public_path__ + "static/media/bookmark_delete.53cc1b398b46d58764d9f8aef43db067.svg";
export { ForwardRef as ReactComponent };